// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {map} from 'lodash';
import classnames from 'classnames';

// Components
import Error from '../core/error';
import Loading from '../core/loading';
import MultiSelect from '../core/multi-select';

// Containers
import withSearch from '../../containers/with-search';

// Styles
import './genre-select.scss';

class GenreSelect extends Component {
    getClass() {
        const {className} = this.props;

        return classnames(
            {
                'genre-select': true,
            },
            className
        );
    }

    getOptions(genres) {
        return map(genres, (genre) => {
            const value = !Config.base.matureContent ? genre : genre.genre;

            return {
                value,
                label: value,
            };
        });
    }

    renderSelect() {
        const { searchData, servicesSearchData, error, label = 'Genre', name = 'genres', validate } = this.props;

        const finalSearchData = Config.base.matureContent
            ? searchData
            : servicesSearchData?.searchData?.standardized_genres;

        if (!error && finalSearchData?.length) {
            return (
                <MultiSelect
                    label={label}
                    multi={true}
                    name={name}
                    operator="=in="
                    options={this.getOptions(finalSearchData)}
                    placeholder="Select genres"
                    updateOptions={Config.base.matureContent}
                    validate={validate}
                />
            );
        }

        return null;
    }

    render() {
        const { error, servicesSearchData, searchData: propSearchData } = this.props;

        const searchData = !Config.base.matureContent
            ? servicesSearchData?.searchData?.standardized_genres
            : propSearchData;

        return (
            <div className={this.getClass()}>
                <Error error={error} />
                <Loading loading={!searchData} />
                {this.renderSelect()}
            </div>
        );
    }
}

GenreSelect.propTypes = {
    className: PropTypes.string,
    error: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
    searchData: PropTypes.array,
    servicesSearchData: PropTypes.object,
    validate: PropTypes.array,
};

export default withSearch(GenreSelect, Config.base.matureContent ? 'genresSelect' : 'bibleMaster');
